import SearchForm from './SearchForm';

export default SearchForm;


// WEBPACK FOOTER //
// ./src/components/forms/SearchForm/index.js